// extracted by mini-css-extract-plugin
export default {"host":"style_host__so7Sp","status":"style_status__rW6Q0","notes":"style_notes__iB6q-"};